import actionTypes from './actionTypes';

const requestNews = (start, limit, fromDate) => ({
    type: actionTypes.REQUEST_NEWS,
    payload: {
        start,
        limit,
        fromDate
    }
});

const newsResponse = (success, newsItems, total, errors) => ({
    type: actionTypes.NEWS_RESPONSE,
    payload: {
        success,
        newsItems,
        total,
        errors
    }
});

const clearCache = () => ({
    type: actionTypes.CLEAR_CACHE
});

export default {
    requestNews,
    newsResponse,
    clearCache
};